import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { State } from 'src/app/reducers';
import { currencyList } from 'src/app/shared/Models/user';
import { selectUser } from 'src/app/shared/user/ngrx/user.selectors';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface TrialBlockBoxDeps {
  currencySymbol?: string;
  minPrice?: number;
  currency?: string;
}

@Component({
  selector: 'trial-block-box',
  templateUrl: './trial-block-box.component.html',
  styleUrls: ['./trial-block-box.component.scss'],
  imports: [MatButtonModule, MatIconModule, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialBlockBoxComponent {
  private ngrxStore = inject<Store<State>>(Store);

  readonly deps = input<TrialBlockBoxDeps>({});
  readonly actionClicked = output<void>();
  readonly closePanel = output<void>();
  readonly completeProfile = output<void>();

  private readonly user = toSignal(this.ngrxStore.select(selectUser));

  readonly depFiltered = computed<TrialBlockBoxDeps>(() =>
    currencyList.find(
      (currencyDetail) =>
        currencyDetail.currency === this.user()?.status?.subscription_currency,
    ),
  );
}
